import { CountingType, WireCountingType } from 'capacity/types'

export const countingTypeFromWire = (wire: WireCountingType): CountingType =>
    wire === 'Gate' ? 'arrivalOnly' : 'wholeTimeSlot'

export const countingTypeToWire = (counting: CountingType): WireCountingType =>
    counting === 'arrivalOnly' ? 'Gate' : 'Venue'
